import { error, finish } from '../../../modules/system-settings/actions/get-bet-limit-settings';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

function createValue(value) {
    if (value === null || value === undefined) {
        return null;
    }
    return $appState.configState.precision.newFromOld(value).value;
}

export function request(dispatch) {
    api.get('/betting-configs', undefined, { cache: true }).then(
        data => {
            const newData = {
                ...data,
                defaultSpPrice: data.defaultSpPrice ?? {
                    den: null,
                    num: null
                },
                maxPayout: createValue(data.maxPayout),
                maxAutoPayout: createValue(data.maxAutoPayout),
                defaultBetLimits: {
                    maxBet: createValue(data.defaultBetLimits.maxBet),
                    maxWin: createValue(data.defaultBetLimits.maxWin),
                    maxMultipleBet: createValue(data.defaultBetLimits.maxMultipleBet),
                    liabilityLimit: createValue(data.defaultBetLimits.liabilityLimit)
                },
                defaultRabBetLimits: {
                    maxBet: createValue(data.defaultRabBetLimits?.maxBet),
                    maxWin: createValue(data.defaultRabBetLimits?.maxWin)
                },
                minTotalStake: createValue(data.minTotalStake),
                minLineStake: createValue(data.minLineStake),
                defaultBetBuilderDelay: data.defaultBetBuilderDelay ?? 5,
            };
            return dispatch(finish(newData));
        },
        (errors) => dispatch(error(errors))
    );
}
